import React from "react";
import { useLocation, NavLink } from "react-router-dom";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import LogoIcon from "./Logo/LogoIcon";
import MenuItems from "../../../Routes/menu";

const Sidebar = ({
  collapsed,
  isMobileSidebarOpen,
  onSidebarClose,
}) => {
  const { pathname } = useLocation();
  const lgUp = useMediaQuery((theme) =>
    theme.breakpoints.up("lg")
  );

  /* ================= SIDEBAR CONTENT ================= */

  const SidebarContent = (
    <Box
      sx={{
        height: "100vh",                     // sidebar stays fixed
        display: "flex",
        flexDirection: "column",
        bgcolor: "#ffffff",
        borderRight: "1px solid rgba(0,0,0,0.08)",
      }}
    >
      {/* ===== LOGO (FIXED) ===== */}
      <Box
        sx={{
          height: 64,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "flex-start",
          px: collapsed ? 0 : 3,
          borderBottom: "1px solid rgba(0,0,0,0.08)",
          overflow: "hidden", 
        }}
      >  <Box
    sx={{
      width: collapsed ? 32 : "auto", // 👈 show only LEFT part
      overflow: "hidden",
      transition: "width 200ms ease",
    }}
  >
    <LogoIcon />
  </Box>
      </Box>

      {/* ===== MENU (ONLY THIS SCROLLS) ===== */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          py: 1,
        }}
      >
        <List disablePadding>
          {MenuItems.map((item) => {
            const active =
              pathname === item.link ||
              pathname.startsWith(item.link + "/");

            const menuItem = (
              <ListItemButton
                key={item.title}
                component={NavLink}
                to={item.link}
                sx={{
                  mx: 1,
                  mb: 0.5,
                  borderRadius: 1,
                  justifyContent: collapsed
                    ? "center"
                    : "flex-start",
                  position: "relative",
                  color: "text.primary",

                  /* Hover */
                  "&:hover": {
                    bgcolor: "rgba(0,0,0,0.04)",
                  },

                  /* Active */
                  ...(active && {
                    bgcolor: "rgba(255, 28, 57, 0.12)", // InstaBlood red tint
                    color: "primary.main",
                    fontWeight: 600,
                  }),
                }}
              >
                {/* Active left indicator */}
                {active && (
                  <Box
                    sx={{
                      position: "absolute",
                      left: -8,
                      top: 8,
                      bottom: 8,
                      width: 4,
                      borderRadius: 2,
                      bgcolor: "primary.main", // InstaBlood red
                    }}
                  />
                )}

                <ListItemIcon
                  sx={{
                    minWidth: collapsed ? "auto" : 40,
                    justifyContent: "center",
                    color: active
                      ? "primary.main"
                      : "text.secondary",
                  }}
                >
                  <item.icon width={20} height={20} />
                </ListItemIcon>

                {!collapsed && (
                  <ListItemText
                    primary={item.title}
                    sx={{
                      whiteSpace: "nowrap",
                    }}
                  />
                )}
              </ListItemButton>
            );

            return collapsed ? (
              <Tooltip
                key={item.title}
                title={item.title}
                placement="right"
              >
                {menuItem}
              </Tooltip>
            ) : (
              menuItem
            );
          })}
        </List>
      </Box>
    </Box>
  );

  /* ================= MOBILE DRAWER ================= */

  if (!lgUp) {
    return (
      <Drawer
        anchor="left"
        open={isMobileSidebarOpen}
        onClose={onSidebarClose}
        variant="temporary"
        PaperProps={{
          sx: {
            width: 220,
            bgcolor: "#ffffff",
            borderRight: "1px solid rgba(0,0,0,0.08)",
          },
        }}
      >
        {SidebarContent}
      </Drawer>
    );
  }

  /* ================= DESKTOP ================= */

  return SidebarContent;
};

export default Sidebar;
